import React, { useEffect, useContext, useState, useRef } from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom';

import Moment from 'moment'

import LanguageContext from "../../../contexts/LanguageContext"

import { Box, Hidden, Button, Drawer, Dialog, CircularProgress } from '@material-ui/core'

import checkGreenRoundIcon from "../../../images/checkGreenRoundIcon.svg"
import closeRedRoundIcon from "../../../images/closeRedRoundIcon.svg"
import sablierIcon from "../../../images/sablierIcon.svg"
import simpleArrowIcon from "../../../images/simpleArrowIcon.svg"
import closeIcon from '../../../images/closeIcon.svg';

import NewCertifChart from "../NewCertifChart"

Moment.locale('fr')

const DialogContent = ({ selectedID, onClose, dataLoaded, getDatasForChart, getMaxYear }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)


  return (
    <Box sx={{
      padding:["30px 25px", "30px 30px", "40px", "40px",]
    }}>
      <Hidden smDown>
        <Box sx={{display:"flex", justifyContent:"flex-end"}}>
          <img
            src={closeIcon}
            style={{width:"20px", height:"20px", cursor:"pointer"}}
            onClick={onClose}
          />
        </Box>
      </Hidden>
      <Hidden smUp>
        <Box sx={{marginBottom:"40px", display:"flex", flexDirection:"column", gap:"10px"}}>
          <Box sx={{color:"text.black", fontSize:"13px"}}>Certification</Box>
          <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
            <Box
              sx={{
                width:"35px",
                height:"35px",
                minWidth:"35px",
                cursor:"pointer",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
              }}
              onClick={onClose}
            >
              <Box sx={{
                width:"19px",
              }}>
                <img src={simpleArrowIcon} style={{width:"100%", transform:"rotate(180deg)"}}/>
              </Box>
            </Box>
            <Box sx={{marginLeft:"10px", fontSize:"25px", color:"text.black", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", textTransform:"uppercase"}}>
              {selectedID?.userName}
            </Box>
          </Box>
        </Box>
      </Hidden>
      {selectedID !== null &&
        <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"40px"}}>
          <Hidden smDown>
            <Box sx={{width:"100%", textTransform:"capitalize", color:"text.black", fontSize:["32px","32px","36px","36px"], textAlign:"center"}}>
              {selectedID.userName}
            </Box>
          </Hidden>
          <Box sx={{display:"flex", width:"100%", flexWrap:["wrap", "nowrap"], gap:"30px 0px"}}>
            <Box sx={{width:['50%', '100%'], overflow:"hidden", textOverflow:"ellipsis", display:"flex", alignItems:["start", "center"], flexDirection:"column", gap:"10px"}}>
              <Box sx={{fontSize:"15px", color:"text.subTitle", textAlign:"center"}}>
                {languageValues?.adminDashboard?.monitoringTable?.graduation[actLanguage]}
              </Box>
              <Box sx={{fontSize:"17px", color:"text.black", textAlign:"center"}}>
                {selectedID?.diplome ? selectedID.diplome : "-"}
              </Box>
            </Box>
            <Box sx={{width:['50%', '100%'], overflow:"hidden", textOverflow:"ellipsis", display:"flex", alignItems:["start", "center"], flexDirection:"column", gap:"10px"}}>
              <Box sx={{maxWidth:"100%", fontSize:"15px", color:"text.subTitle", textAlign:"center", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>
                {languageValues?.adminDashboard?.monitoringTable?.graduationYear[actLanguage]}
              </Box>
              <Box style={{fontSize:"17px", color:"text.black", textAlign:"center"}}>
                {selectedID?.anneeDiplome ? selectedID.anneeDiplome : "-"}
              </Box>
            </Box>
            <Box sx={{width:['50%', '100%'], overflow:"hidden", textOverflow:"ellipsis", display:"flex", alignItems:["start", "center"], flexDirection:"column", gap:"10px"}}>
              <Box sx={{fontSize:"15px", color:"text.subTitle", textAlign:"center"}}>
                {languageValues?.adminDashboard?.monitoringTable?.progress[actLanguage]}
              </Box>
              <Box sx={{color:"text.black", fontSize:"17px", textAlign:"center"}}>
                {selectedID?.status === "ended" &&
                  <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%",}}>
                    <img src={checkGreenRoundIcon} style={{width:"20px"}}/>
                    <Box sx={{fontSize:"17px"}}>
                      <Hidden only={["sm"]}>
                        <font>
                          {languageValues?.adminDashboard?.monitoringTable?.statusEnded[actLanguage]}
                        </font>
                      </Hidden>
                    </Box>
                  </Box>
                }
                {selectedID?.status === "inProgress" &&
                  <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                    <Box sx={{position:"relative", height:"20px"}}>
                      <CircularProgress variant="determinate" value={100} thickness={5.5} size="20px" sx={{color: '#E7E7E7'}} />
                      <CircularProgress
                        variant="determinate"
                        value={selectedID.statusProgress}
                        thickness={6}
                        size="20px"
                        sx={{
                          color: "black",
                          position: 'absolute',
                          left: 0,
                        }}
                      />
                    </Box>
                    <Box sx={{fontSize:"17px"}}>
                      <Hidden mdDown>
                        {languageValues?.adminDashboard?.monitoringTable?.statusProgress[actLanguage]}
                        {selectedID.statusProgress}%
                      </Hidden>
                      <Hidden mdUp>
                        {selectedID.statusProgress}%
                      </Hidden>
                    </Box>
                  </Box>
                }
                {selectedID?.status === "notStarted" &&
                  <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                    <Box sx={{position:"relative", height:"20px"}}>
                      <img src={sablierIcon} style={{height:"18px", marginLeft:"3px"}} />
                    </Box>
                    <Box sx={{fontSize:"17px"}}>
                      <Hidden mdDown>
                        {languageValues?.adminDashboard?.monitoringTable?.statusNotStarted[actLanguage]}
                      </Hidden>
                      <Hidden mdUp>
                        {selectedID.statusProgress}%
                      </Hidden>
                    </Box>
                  </Box>
                }
              </Box>
            </Box>
            <Box sx={{width:['50%', '100%'], verflow:"hidden", textOverflow:"ellipsis", display:"flex", alignItems:["start", "center"], flexDirection:"column", gap:"10px"}}>
              <Box sx={{fontSize:"15px", color:"text.subTitle", textAlign:"center"}}>
                {languageValues?.adminDashboard?.monitoringTable?.level[actLanguage]}
              </Box>
              <Box sx={{fontSize:"17px", color:"black", textAlign:"center"}}>
                {selectedID?.level === "notAcquired" &&
                  <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%",}}>
                    <img src={closeRedRoundIcon} style={{width:"20px"}}/>
                    <Box sx={{fontSize:"17px"}}>
                      <Hidden only={["sm"]}>
                        <font>
                          {languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]}
                        </font>
                      </Hidden>
                    </Box>
                  </Box>
                }
                {selectedID?.level === "rattrapage" &&
                  <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%",}}>
                    <img src={closeRedRoundIcon} style={{width:"20px"}}/>
                    <Box sx={{fontSize:"17px"}}>
                      <Hidden only={["sm"]}>
                        <font>
                          {languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]}
                        </font>
                      </Hidden>
                    </Box>
                  </Box>
                }
                {selectedID?.level === "inProgress" &&
                  <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                    {languageValues?.adminDashboard?.levelTypes?.inProgress[actLanguage]}
                  </Box>
                }
                {selectedID?.level === "acquired" &&
                  <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                    <img src={checkGreenRoundIcon} style={{width:"20px"}}/>
                    <Box sx={{fontSize:"17px"}}>
                      <Hidden only={["sm"]}>
                        {languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]}
                      </Hidden>
                    </Box>
                  </Box>
                }
              </Box>
            </Box>
          </Box>
          <Box sx={{display:"flex", width:"100%"}}>
            <Box sx={{width:"100%", marginTop:"-50px"}}>
              <NewCertifChart
                datas={getDatasForChart(selectedID)}
              />
              <Box sx={{width:"100%", justifyContent:"center", gap:["20px", "40px"], color:"text.black", marginTop:'-10px', marginBottom:"20px", fontSize:["11px", "13px", "13px", "13px"], display:"flex"}}>
                <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                  <Box sx={{width:['30px',' 40px'], borderTop:"2px dotted rgba(0, 0, 0, 0.6)"}} />
                  <Box>{languageValues?.adminDashboard?.dashCertif?.yearBtn[actLanguage]} 1</Box>
                </Box>
                <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                  <Box sx={{width:['30px',' 40px'], borderTop:"2px dashed rgba(0, 0, 0, 0.6)"}} />
                  <Box>{languageValues?.adminDashboard?.dashCertif?.yearBtn[actLanguage]} 2</Box>
                </Box>
                {getMaxYear(selectedID) >= 2 &&
                  <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                    <Box sx={{width:['30px',' 40px'], borderTop:"2px solid rgba(0, 0, 0, 0.6)"}} />
                    <Box>{languageValues?.adminDashboard?.dashCertif?.yearBtn[actLanguage]} 3</Box>
                  </Box>
                }
              </Box>
            </Box>
          </Box>
        </Box>
      }

    </Box>
  )
}

const CertifModal = ({isOpen, onClose, selectedID, dataLoaded, getDatasForChart, getMaxYear}) => {

  return (
    <>
      <Hidden smUp>
        <Drawer
          anchor='bottom'
          open={isOpen}
          onClose={onClose}
          sx={{
            //background:"transparent",
          }}
          PaperProps={{
            sx: {
              height: 'calc(100% - 105px)',
              width : 'calc(100vw)',
              top: '105px',
              left : '0px',
              backgroundColor: "background.grey",
              //overflow:"hidden"
            },
          }}
        >
          <DialogContent
            onClose={onClose}
            selectedID={selectedID}
            dataLoaded={dataLoaded}
            getDatasForChart={getDatasForChart}
            getMaxYear={getMaxYear}
          />
        </Drawer>
      </Hidden>


      <Hidden smDown lgUp>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={isOpen}
          onClose={onClose}
          PaperProps={{
            sx : {
              borderRadius:"0px",
              border:"1px solid black",
              overflow:"hidden"
            }
          }}
        >
          <DialogContent
            onClose={onClose}
            selectedID={selectedID}
            dataLoaded={dataLoaded}
            getDatasForChart={getDatasForChart}
            getMaxYear={getMaxYear}
          />
        </Dialog>
      </Hidden>
    </>
  )
}


export default CertifModal
